<template>
  <div class="planning-shifts-list">
    <NoRecruitment
      v-if="shiftsList.length === 0"
      :title="$t('ETAB.PAGES.PLANNING.@NO_PLANNING_DEMAND')"
      :img="inProgressImg"
      :btn-label="$t('ETAB.BUTTONS.@CREATE_DEMAND')"
      :btn-action="goToCreation"
    />
    <section v-for="group in shiftsList" :key="group.getFormattedDate()">
      <header>
        <h4>
          {{ group.getFormattedDate() }}
        </h4>
        <h5 v-if="group.getNbExtraRequired()">
          {{ $tc("ETAB.PAGES.PLANNING.@EXTRA_BOOKED", group.getNbExtraBooked()) }}
          {{ $tc("ETAB.PAGES.PLANNING.@EXTRA_REQUIRED", group.getNbExtraRequired()) }}
        </h5>
      </header>
      <QList>
        <PlanningShift v-for="shift in group.getShiftsBooked()" :key="shift.getJobId()" :shift="shift" />
        <PlanningShift v-for="shift in group.getShiftsCanceled()" :key="shift.getJobId()" :shift="shift" />
      </QList>
    </section>
  </div>
</template>

<script setup>
  import inProgressImg from "@etab/assets/img/no_in_progress_demand.svg";
  import { PlanningShiftsGroupModel } from "@core/models";
  import { ETAB_ROUTES } from "@etab/config";
  import PlanningShift from "@etab/components/planning/PlanningShift.component.vue";
  import NoRecruitment from "@etab/components/dashboard/NoRecruitment.functional.vue";
  import { useRouter } from "vue-router";

  const router = useRouter();

  // Props
  const props = defineProps({
    shiftsList: {
      type: Array,
      default: () => [new PlanningShiftsGroupModel()],
    },
  });

  // Methods
  const goToCreation = function () {
    router.push({ name: ETAB_ROUTES.creation.root.name }).catch((suppressedError) => {});
  };
</script>

<style lang="scss">
  .planning-shifts-list {
    > section {
      padding: 5px 0;
      > header {
        margin: 15px 0;
        h4 {
          margin: 5px 0;
          color: $accent;
          font-weight: bold;
          font-family: $title-font-family;
          line-height: 1.18;
          letter-spacing: 1px;
          text-transform: capitalize;
        }
        h6 {
          margin: 0;
          font-style: italic;
          color: $primary-light;
        }
      }
    }
  }
</style>
